import { useNavigate, useLocation } from "react-router-dom";
import { Settings, User, Heart, FolderKanban, CreditCard, FileText, Wallet, SlidersHorizontal, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "../ui/dropdown-menu";

export const ACCOUNT_NAV = [
  { label: "Profile", to: "/profile", icon: User },
  { label: "Favorites", to: "/account/favorites", icon: Heart },
  { label: "My Projects", to: "/account/projects", icon: FolderKanban },
  { label: "Plans & Subscription", to: "/account/plans", icon: CreditCard },
  { label: "Invoice History", to: "/account/invoices", icon: FileText },
  { label: "Payment Methods", to: "/account/payment-methods", icon: Wallet },
  { label: "Account Settings", to: "/account/settings", icon: SlidersHorizontal },
];

export const SettingsMenu = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2.5 text-sm font-semibold text-[#0F0F0F] hover:border-[#D4AF37] transition-colors"
          data-testid="account-settings-menu-trigger"
        >
          <Settings size={16} /> Settings <ChevronDown size={14} className="opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-xl p-1.5">
        <DropdownMenuLabel className="text-[11px] uppercase tracking-wide text-[#9CA3AF]">
          Account
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {ACCOUNT_NAV.map((item) => {
          const Icon = item.icon;
          const active = pathname === item.to;
          return (
            <DropdownMenuItem
              key={item.to}
              onClick={() => navigate(item.to)}
              className={`cursor-pointer gap-2.5 rounded-lg py-2.5 text-sm font-medium ${active ? "bg-[#F7F7F7] text-[#0F0F0F]" : "text-[#374151]"}`}
              data-testid={`account-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "")}`}
            >
              <Icon size={16} className="text-[#D4AF37]" /> {item.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
